<template>
	<div class="condition-value">
		<div class="type-selectors">
			<GroupRadio :data="typeOptions" v-model="type" />
		</div>
		<div style="padding: 0 5px">
			<div class="d-flex" v-if="type === 'manual'">
				<GroupRadio :data="manualTypeOptions" v-model="localData.type" class="manual-radio" />

				<select v-if="localData.type === 'staticValue' && enumItems" v-model="localData.value" style="min-width: 100px" class="qd-dropdown">
					<option v-for="enumItem in enumItems" :key="enumItem.key" :value="enumItem.key">
						{{ enumItem.value }}
					</option>
				</select>
				<date-picker v-else-if="localData.type === 'staticValue' && isDate" :options="componentOptions.date" v-model="localData.value" />
				<div v-else-if="localData.type === 'staticValue' && isBoolean">
					<label><input type="radio" v-model="localData.value" value="1" /> بلی </label>
					<label><input type="radio" v-model="localData.value" value="0" /> خیر </label>
				</div>
				<input v-else-if="localData.type === 'staticValue' && !enumItems" type="text" v-model="localData.value" class="qd-input" />
				<div v-else-if="localData.type === 'staticList'" style="display: flex">
					<select v-if="enumItems" v-model="staticListItem" style="min-width: 100px" class="qd-dropdown">
						<option v-for="enumItem in enumItems" :key="enumItem.key" :value="enumItem.key">
							{{ enumItem.value }}
						</option>
					</select>
					<date-picker v-else-if="isDate" :options="componentOptions.date" v-model="staticListItem" />
					<input v-else type="text" v-model="staticListItem" class="qd-input" />
					<select style="min-width: 70px" class="qd-dropdown static-list">
						<option v-for="ct in localData.value.split(',')" :key="ct">
							{{ ct }}
						</option>
					</select>
					<button @click="addStaticListItem()" class="qd-button">افزودن</button>
				</div>
			</div>

			<select v-else v-model="localData.key" style="min-width: 100px" @change="dropdownChanged" class="qd-dropdown">
				<optgroup label="متغیرها">
					<option v-for="ct in variableItems" :key="ct.key" :value="ct.key">
						{{ ct.title }}
					</option>
				</optgroup>
				<optgroup label="پارامترهای گزارش">
					<option v-for="ct in reportParameterItems" :key="ct.key" :value="ct.key">
						{{ ct.title }}
					</option>
				</optgroup>
				<optgroup label="فیلدهای گزارش">
					<option v-for="col in reportColumns" :key="col.path" :value="col.path">
						{{ col.title }}
					</option>
				</optgroup>
			</select>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'
	import GroupRadio from '../components/general/group-radio.vue'

	export default {
		props: {
			col: {
				type: Object,
			},
			modelValue: {
				type: Object,
			},
			fields: {
				type: Array,
			},
			variables: {
				type: Array,
				default: () => [],
			},
		},
		emits: ['update:modelValue'],
		components: {
			GroupRadio
		},
		data() {
			return {
				typeOptions: [
					{
						name: 'دستی',
						value: 'manual'
					},
					{
						name: 'اتصال',
						value: 'connect'
					}
				],
				manualTypeOptions: [
					{
						name: 'ثابت',
						value: 'staticValue'
					},
					{
						name: 'لیست',
						value: 'staticList'
					},
				],
				uniqueId: Date.now().toString(),
				type: 'manual',
				staticListItem: '',
				localData: {
					value: '',
					type: '',
					key: '',
				},
				componentOptions: {
					date: {}
				}
			}
		},
		watch: {
			localData: {
				deep: true,
				handler() {
					this.$emit('update:modelValue', this.localData)
				},
			},
		},
		mounted() {
			this.localData = { ...this.modelValue }
			this.type = ['staticValue', 'staticList'].indexOf(this.localData.type) > -1 ? 'manual' : 'connect'
		},
		computed: {
			...mapGetters({
				reportParameters: 'queryDesigner/reportParameters',
			}),
			variableItems() {
				let items = []
				this.variables.forEach((variable) => {
					variable.dynamicValue.columns.forEach((col) => {
						items.push({
							title: `${variable.name}:${col.alias ? col.alias : col.titlePath}`,
							key: `${variable.key}:${col.path}`,
						})
					})
				})
				return items
			},
			reportParameterItems() {
				let items = []
				let mapped = this.reportParameters.map((v) => {
					return {
						title: v.name,
						key: `parameter:${v.key}:${v.path}`,
					}
				})
				if (mapped.length) items.push(...mapped)
				return items
			},
			reportColumns() {
				let items = []
				let mapped = this.fields.map((v) => {
					return {
						title: v.title,
						key: `otherColumn:${v.path}`,
					}
				})
				if (mapped.length) items.push(...mapped)
				return items
			},
			enumItems() {
				if (this.col?.type.toLowerCase().indexOf('enum') > -1)
					return this.col.enumItems.map(x => {
						return {
							key: x.key,
							value: this.$t(`enum-items.${this.col.type.split('_')[1]}.${x.value}`)
						}
					})
				return null
			},
			isDate() {
				return this.col?.type.toLowerCase() === 'datetime'
			},
			isBoolean() {
				return this.col?.type.toLowerCase() === 'boolean'
			}
		},
		methods: {
			addStaticListItem() {
				this.localData.value += ',' + this.staticListItem
				if (this.localData.value && this.localData.value[0] === ',')
					this.localData.value = this.localData.value.substring(1, this.localData.value.length)
				this.staticListItem = ''
			},
			dropdownChanged(e) {
				if (!e.target.value) return
				if (/^v.+\:/.test(e.target.value)) this.localData.type = 'variable'
				else if (e.target.value.indexOf('parameter:') > -1) this.localData.type = 'parameter'
				else if (e.target.value.indexOf('otherColumn:') > -1) this.localData.type = 'otherColumn'
			},
		},
	}
</script>

<style></style>